import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CardTitle } from "./ProfileCard";

export function DangerCard({ data }) {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);
  const admin = data.role === "admin";

  const remove = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/account/delete", data.has_password ? { password: secret } : { confirm: secret });
      toast.success("Your account was deleted");
      setSession(false);
      navigate("/login");
    } catch (err) { toast.error(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <section className="as-card as-danger" data-testid="danger-card">
      <CardTitle icon={Trash2} tone="red">Danger zone</CardTitle>
      <b>Delete account</b>
      <p>Permanently delete your account and all its data. This cannot be undone.</p>
      {admin ? (
        <p className="as-muted" data-testid="danger-admin-note">Admin accounts cannot be deleted from here.</p>
      ) : !open ? (
        <button type="button" className="as-danger-button" onClick={() => setOpen(true)} data-testid="delete-account-btn">Delete account</button>
      ) : (
        <form className="as-fields" onSubmit={remove} data-testid="delete-account-form">
          <label>{data.has_password ? "Enter your password to confirm" : `Type ${data.email} to confirm`}
            <input type={data.has_password ? "password" : "text"} value={secret} onChange={(e) => setSecret(e.target.value)} required data-testid="delete-confirm-input" />
          </label>
          <div className="as-row">
            <button type="button" className="as-secondary" onClick={() => { setOpen(false); setSecret(""); }} data-testid="delete-cancel-btn">Cancel</button>
            <button className="as-danger-solid" disabled={busy || !secret} data-testid="delete-confirm-btn">Delete permanently</button>
          </div>
        </form>
      )}
    </section>
  );
}
